module.exports = __webpack_public_path__ + "img/rare-3.6f870fbb.png";